import { Navigate, Route, Routes } from "react-router-dom";
import Box from "@mui/material/Box";
import Header from "./layout/header";
import Footer from "./layout/footer";
import Home from "views/Home";
import AboutUs from "views/AboutUs";
import Blogs from "views/Blogs/Blogs";
import Blog1 from "views/Blogs/Blog1";
import Blog2 from "views/Blogs/Blog2";
import Blog3 from "views/Blogs/Blog3";
import Blog4 from "views/Blogs/Blog4";
import Blog5 from "views/Blogs/Blog5";
import Careers from "views/Careers";
import ContactUs from "views/ContactUs";

function App() {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />

      {/* Page content area — offset for fixed header */}
      <Box component="div" sx={{ pt: { xs: "80px", md: "135px" }, flex: 1 }}>
        <Routes>
          <Route path="/" element={<Navigate to="home" replace />} />

        <Route path="home" element={<Home />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="blogs" element={<Blogs />} />
          <Route
            path="blogs/thriving-in-diversity-cultivating-trust-and-camaraderie-in-global-teams"
            element={<Blog1 />}
          />
          <Route
            path="blogs/the-anatomy-of-high-performing-teams-part-2"
            element={<Blog2 />}
          />
          <Route
            path="blogs/the-anatomy-of-high-performing-teams-part-1"
            element={<Blog3 />}
          />
          <Route
            path="blogs/leading-with-purpose-a-pc-perspective"
            element={<Blog4 />}
          />
          <Route
            path="blogs/climbing-the-ladder-learning-adapting-and-leading-with-authenticity"
            element={<Blog5 />}
          />
          <Route path="careers" element={<Careers />} />
          <Route path="contact" element={<ContactUs />} />

          <Route path="*" element={<Navigate to="home" replace />} />
        </Routes>
      </Box>

      <Footer />
    </Box>
  );
}

export default App;
